module.exports = __webpack_public_path__ + "media/images/emblems/Pura-coat_of_arms-c0281ed58316588146e9e754b36bb742.svg";